// TelcoTrack — text protokolu / smlouvy u dalšího podpisu ve stavebním deníku.
// Uložený text a PNG podpisu jsou dvě pole. Po znovuotevření se text nesmí
// přepsat vygenerovaným mustrem jen proto, že se obnoví datum nebo obec.

export interface DiaryProtocolNoteOpenState {
  /** Text, který se má ukázat v textarea. */
  note: string;
  /**
   * Poslední automatický mustr. Ruční úprava se pozná tak, že `note` se od něj liší.
   * Když se sem uloží samotný uložený text, další sync ho přepíše mustrem a podpis zůstane.
   */
  lastAutoNote: string;
}

/**
 * Stav po načtení uloženého řádku.
 * `lastAutoNote` je vždy vygenerovaný mustr, ne uložený text.
 */
export function diaryProtocolNoteStateOnOpen(input: {
  savedNote: string;
  generatedNote: string;
}): DiaryProtocolNoteOpenState {
  const saved = input.savedNote.trim();
  const generated = input.generatedNote.trim();
  return {
    note: saved,
    lastAutoNote: generated,
  };
}

/** Má sync data/obce/závad přepsat textarea mustrem? */
export function shouldReplaceDiaryProtocolNote(input: {
  currentNote: string;
  lastAutoNote: string;
  force?: boolean;
}): boolean {
  if (input.force) return true;
  const current = input.currentNote.trim();
  if (!current) return true;
  return current === input.lastAutoNote.trim();
}
